import React from 'react'
import COLORS from '../styles/colors'

type Props = {
  onClick: (e: any) => void
  style?: any
  className?: string
}

const FacebookButton = (props: Props) => {
  return (
    <button style={{ ...defaultStyle, ...props.style }} className={props.className} onClick={props.onClick}>
      Entrar com o Facebook
    </button>
  )
}

FacebookButton.defaultProps = {
  className: '',
  style: {},
}

const defaultStyle = {
  facebookButton: {
    backgroundColor: COLORS.uiSpecific.facebookBlue,
    color: COLORS.greyscale.white,
    marginBottom: 16,
    fontFamily: 'Lato',
  },
}

export default FacebookButton
